import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME = 'CustomActionEditAccess';
export const CUSTOM_ACTION_EDIT_ACCESS_CLASS_SLOTS = [
	'root',
	'label',
	'selector',
] as const;

export type CustomActionEditAccessClassSlot =
	(typeof CUSTOM_ACTION_EDIT_ACCESS_CLASS_SLOTS)[number];

export interface CustomActionEditAccessClasses {
	root: string;
	label: string;
	selector: string;
}

export type CustomActionEditAccessClassKey =
	keyof CustomActionEditAccessClasses;

export const getCustomActionEditAccessUtilityClass = (slot: string) =>
	generateUtilityClass(CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME, slot);

export const customActionEditAccessClasses = generateUtilityClasses<
	keyof CustomActionEditAccessClasses
>(CUSTOM_ACTION_EDIT_ACCESS_CLASS_NAME, ['root', 'label', 'selector']);
export default customActionEditAccessClasses;
